exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".condition-builder-container[data-v-11bab19a] {\n  overflow-y: auto;\n  max-height: 350px;\n}\n", ""]);

// exports
